/**
 * @module systemManager
 */
import { device as defaultDevice } from "../../../web/manager/system/device";
import { device as lgDevice } from "./device";
import { application } from "./application";
import { network } from "./network";

const device = Object.assign(defaultDevice, lgDevice);
export const system = {
  device,
  application,
  network
};
